import React, { useEffect, memo, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import {
    Grid,
    Paper,
    Table,
    TableContainer,
    TableRow,
    TableHead,
    TableCell,
    TableBody,
    TablePagination,
    FormControlLabel,
    Switch
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { TraerCotizaciones, TraerEstadosSolicitud } from "../../../actions/compras/Cotizaciones";
import { CotizacionesItem } from "./CotizacionesItem";
import { ESTADOS_COTIZACIONES } from "../../../utils/constants";
const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
        // width: "100%",
    }
});
export const ListadoCotizaciones = memo((props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { cotizaciones, estados, estadosSolicitud, idSolicitudCompras, fechaInicioCompras, fechaFinCompras } = useSelector((state) => state.compras)
    const { afiliadoSeleccionado } = useSelector((state) => state.autorizaciones);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [dense, setDense] = useState(true);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const componentRef = React.useRef();

    useEffect(() => {
        dispatch(TraerCotizaciones(
            Number(estadosSolicitud),
            afiliadoSeleccionado?.id_afiliado,
            idSolicitudCompras,
            fechaInicioCompras,
            fechaFinCompras,
            props.idTipoSolicitud))
        dispatch(TraerEstadosSolicitud())
    }, [estadosSolicitud,
        afiliadoSeleccionado?.id_afiliado,
        idSolicitudCompras,
        fechaInicioCompras,
        fechaFinCompras,
        props.menu])


    return (
        <div>
            <Grid>
                <Grid container justify="center" className={classes.root} spacing={1}>
                    <Grid item xs={12}>
                        <Paper>
                            <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                                <Table size={dense ? "small" : "medium"} ref={componentRef}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>Estado</TableCell>
                                            {(Number(estadosSolicitud) === ESTADOS_COTIZACIONES.COTIZACIONES_SOLICITADAS ||
                                            Number(estadosSolicitud) === ESTADOS_COTIZACIONES.ANULADAS) && (
                                                <>
                                                    <TableCell>Fecha Solicitud</TableCell>
                                                    <TableCell>N° Orden</TableCell>
                                                    <TableCell>Tipo Solicitud</TableCell>
                                                    <TableCell>Fecha Cirugía</TableCell>
                                                    <TableCell>Programada</TableCell>
                                                    <TableCell>Afiliado</TableCell>
                                                    <TableCell>Institucion</TableCell>
                                                    <TableCell>Prestador</TableCell>
                                                    <TableCell>Practicas</TableCell>
                                                    <TableCell></TableCell>
                                                </>
                                            )}
                                            {Number(estadosSolicitud) === ESTADOS_COTIZACIONES.PENDIENTE_ACEPTACION && (
                                                <>
                                                    <TableCell>N° Orden</TableCell>
                                                    <TableCell>Fecha Envio</TableCell>
                                                    <TableCell>Afiliado</TableCell>
                                                    <TableCell>N° Afiliado</TableCell>
                                                    <TableCell>Diagnostico</TableCell>
                                                </>
                                            )}
                                            {Number(estadosSolicitud) === ESTADOS_COTIZACIONES.COTIZACIONES_ACEPTADAS && (
                                                <>
                                                    <TableCell>N° Orden</TableCell>
                                                    <TableCell>Fecha Aceptacion</TableCell>
                                                    <TableCell>Afiliado</TableCell>
                                                    <TableCell>N° Afiliado</TableCell>
                                                    <TableCell>Fecha Cirugia</TableCell>
                                                </>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {cotizaciones?.length > 0 ? (
                                            cotizaciones
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((item) => (
                                                    <CotizacionesItem
                                                        item={item.solicitud}
                                                        estadoSolicitud={estadosSolicitud}
                                                        cotizaciones={item}
                                                        key={item.idCotizacion.toString()}
                                                        estadosCotizacion={estados}
                                                        idTipoSolicitud={props.idTipoSolicitud}
                                                    />
                                                ))
                                        ) : (<TableRow style={{ height: 50 }}>
                                            <TableCell
                                                colSpan={13}
                                                style={{ textAlign: "-webkit-center" }}
                                            >
                                                {" "}
                                                Sin Registros
                                            </TableCell>
                                        </TableRow>)}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                    {cotizaciones?.length > 0 && (
                        <Grid item xs={12}>
                            <TablePagination
                                style={{ backgroundColor: "white" }}
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={cotizaciones.length}
                                rowsPerPage={rowsPerPage}
                                labelRowsPerPage="Registros por página"
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={dense}
                                        onChange={(e) => setDense(e.target.checked)}
                                    />
                                }
                                label="Tamaño compacto"
                            />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </div>
    )
});
